var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.pessoa && _vm.pessoa.id)?_c('a',{staticClass:"pessoa-link",on:{"click":function($event){return _vm.gotoPerson(_vm.pessoa)}}},[_vm._v(_vm._s(_vm.pessoa.name))]):_c('span',[_vm._v(_vm._s(_vm.pessoa ? _vm.pessoa.name : '-'))])
}
var staticRenderFns = []

export { render, staticRenderFns }